module.exports = __webpack_public_path__ + "static/DAWCode-b1adaa95193d5a3594549d1d760027bd.png";